import React, {  PureComponent } from "react";
import { TransactionHistoryStatus } from "./TransactionHistoryConstants";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
// import RiderSupportAnsCard from '../../Cards/UploadBannerCard/RiderSupportAnsCard'
import Loading from "../../Utils/Loading";
import TransactionHistory from "../TransactionsHistoryPoints"
import {Api_Pagination} from 'RefRecordsConstants'
export class TransactionHistoryView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      activePage:props.activePage
      // submitted_dttm:props.submitted_dttm,
      // isAnswered:props.isAnswered,
      // activePage:props.activePage
    };
    // this.getRiderUnAnsweredQuestions()
  }

  // getRiderUnAnsweredQuestions = ()=>{

  //   const data = {
  //     offset : 0,
  //     submitted_dttm :this.props.submitted_dttm,
  //     props:this.props
  //   }

  //   if(this.props.isAnswered == "Answered"){
    
  //     this.props.getRiderAnsweredQuestions(data)
  //   }
  //   else{
  //     this.props.getRiderUnAnsweredQuestions(data)
  //   }
  // }
  static getDerivedStateFromProps(nextProps, prevState){
    if(nextProps.TransactionHistory_GET_status ===TransactionHistoryStatus.TransactionHistory_GET.SUCCESS ||
      nextProps.TransactionHistory_GET_status ===TransactionHistoryStatus.TransactionHistory_GET.FAILED)
      nextProps.setLoading(false)
    
    if(nextProps.user_id_flag && nextProps.TransactionHistory_GET_status !==TransactionHistoryStatus.TransactionHistory_GET.LOADING){
      // alert(nextProps.user_id)
      let data={
        user_id:nextProps.user_id,
        offset: (nextProps.activePage - 1) * Api_Pagination.PointsHistoryLimit
      }
      nextProps.getRedeemedCouponsByUserId(data)
      nextProps.clear_user_id()
      nextProps.setLoading(true)
    }
    
  //   if(prevState.submitted_dttm !== nextProps.submitted_dttm || prevState.isAnswered !== nextProps.isAnswered || prevState.activePage !== nextProps.activePage){
  //     const data = {
  //       offset : (nextProps.activePage - 1) * 10,
  //       submitted_dttm :nextProps.submitted_dttm ,
  //       props:nextProps
  //     }
  //     if(nextProps.isAnswered == "Answered"){
    
  //       nextProps.getRiderAnsweredQuestions(data)
  //     }
  //     else{
  //       nextProps.getRiderUnAnsweredQuestions(data)
  //     }
  //     return{
  //       submitted_dttm:nextProps.submitted_dttm,
  //       isAnswered:nextProps.isAnswered,
  //       activePage:nextProps.activePage
  //     }
  //  }
   
   return null;
 }
  getScreen(status) {
    switch (status) {
      case TransactionHistoryStatus.TransactionHistory_GET.NEW:
        return (
          <TransactionHistory  data={this.props.TransactionHistory} />
        );

      case TransactionHistoryStatus.TransactionHistory_GET.SUCCESS:
      // alert(JSON.stringify(this.props.TransactionsCount))
      console.log("this.props.TransactionHistory:", this.props.TransactionHistory)
        return (
          <TransactionHistory  data={this.props.TransactionHistory} 
          setNoOfPages={this.props.setNoOfPages} TransactionsCount={this.props.TransactionsCount}
          />
          // this.props.TransactionHistory.length > 0 ?
          // this.props.TransactionHistory.map((item)=>{
          //   return(

          //     <RiderSupportAnsCard key ={item.rider_support_request_id}
          //     email_address = {item.email_address}
          //     submitted_dttm = {this.state.submitted_dttm}
          //     question = {item.question}
          //     response = {item.response}
          //     response_dttm = {item.response_dttm}
          //     isAnswered = {this.state.isAnswered}
          //     rider_support_request_id = {item.rider_support_request_id}
          //     getRiderUnAnsweredQuestions = {this.getRiderUnAnsweredQuestions}
          //     phone = {item.phone}
          //     />
          
          //   )
          // }):
          // this.state.isAnswered == "Answered"?
          // < QuestionsEmptyScreen message = {"No Answered Questions yet"} />
          // :< QuestionsEmptyScreen message = {"No Unanswered Questions yet"} />
          
        );
        break;
      case TransactionHistoryStatus.TransactionHistory_GET.FAILED:
        
        toast.error(this.props.TransactionHistory_Error)
        return (
          <TransactionHistory  data={[]} />
           );

      case TransactionHistoryStatus.TransactionHistory_GET.LOADING:
     
        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Loading />
          </div>
        );
        break;
      default:
        return <div />;
    }
  }
  render() {
    return this.getScreen(this.props.TransactionHistory_GET_status);
  }
}

export default TransactionHistoryView;
